import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '@services/app.service';
import { User } from 'firebase/auth';
import { Observable } from 'rxjs';

const BASE_CLASSES = 'main-sidebar elevation-4';

@Component({
  selector: 'app-menu-sidebar',
  templateUrl: './menu-sidebar.component.html',
  styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
  @HostBinding('class') classes: string = BASE_CLASSES;
  public ui!: Observable<UiState>;
  public user?: User;

  public menu: any[] = [];

  userType: string = "";

  constructor(
    public appService: AppService,
    private store: Store<AppState>
  ) { }

  ngOnInit() {

    this.ui = this.store.select('ui');

    this.ui.subscribe((state: UiState) => {
      this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
    });

    this.user != this.appService.user;

    this.userType = localStorage.getItem("userType") || "";

    // ADMIN -> only MENU
    if (this.userType === 'ADMIN') {
      this.menu = [...MENU];
    }

    // SUPER_ADMIN -> MENU + SUPER_ADMIN_MENU
    else if (this.userType === 'SUPER_ADMIN') {
      this.menu = [
        ...MENU,
        ...SUPER_ADMIN_MENU
      ];
    }

    // default fallback
    else {
      this.menu = [...MENU];
    }
  }
}

export const MENU = [
  {
    name: 'Add Category',
    iconClasses: 'fas fa-medal',
    path: ['/main/add-category']
  },
  {
    name: 'Product',
    iconClasses: 'fas fa-box-open',
    children: [
      {
        name: 'New Product',
        iconClasses: 'fas fa-industry',
        path: ['/main/add-new-product']
      },
      {
        name: 'Product View',
        iconClasses: 'fas fa-list-alt',
        path: ['/main/product-view']
      }
    ]
  },
  {
    name: 'Barcode Print page',
    iconClasses: 'fas fa-print',
    path: ['/main/barcode-print-page']
  },
  {
    name: 'Free Stage Entry',
    iconClasses: 'bi bi-chat-dots',
    path: ['/main/free-stage-entry']
  },
  {
    name: 'Order Processing',
    iconClasses: 'bi bi-receipt',
    path: ['/main/order-processing']
  },
  {
    name: 'Dispatch Management',
    iconClasses: 'bi-box-seam',
    path: ['/main/dispatch-management']
  },
  {
    name: 'Create Shop Bill',
    iconClasses: 'fas fa-receipt',
    path: ['/main/invoice']
  },
  {
    name: 'Shop Bill List',
    iconClasses: 'fas fa-list-alt',
    path: ['/main/shop-bill-list']
  },
  {
    name: 'Transaction Details',
    iconClasses: 'fas fa-money-bill',
    path: ['/main/transaction-details']
  },
  {
    name: 'Report Details',
    iconClasses: 'fas fa-file',
    path: ['/main/report-details']
  },
];

export const SUPER_ADMIN_MENU = [
  {
    name: 'Activity Logs',
    iconClasses: 'fas fa-tasks',
    path: ['/main/activity-log']
  },
]
